/* NPTA custom GA4 events.
 *
 * GA4 (G-M4PQ4FS3Z1) reaches the site through Shopify's Google & YouTube web
 * pixel, which runs in the OPEN runtime context -- meaning it executes in the
 * page rather than a sandboxed iframe, and so it owns window.dataLayer. That
 * lets us add events by pushing in gtag's own argument shape, which is all
 * gtag('event', ...) does internally. We deliberately do NOT load a second
 * copy of gtag.js: that would re-fire page_view and double every session.
 *
 * Shopify's pixel already reports the eleven standard ecommerce events
 * (page_view, view_item, add_to_cart, purchase ...). This adds the one thing
 * it cannot know about: which call to action someone actually clicked.
 *
 * Events sent from here:
 *   cta_click     any button or button-styled link, with its label
 *   generate_lead the advisor popup, on a confirmed webhook success
 *
 * IMPORTANT: cta_label and cta_location are custom parameters. GA4 collects
 * them immediately but will not show them in reports until they are
 * registered as custom dimensions under Admin -> Custom definitions.
 */
(function () {
  'use strict';

  /* Our own GA4 property. The other G- id on this site (G-M4PQ4FS3Z1) belongs
     to a different team and arrives via Shopify's Google & YouTube app, so
     every event below is addressed with send_to -- without it gtag fans an
     event out to every configured destination, and our custom events would
     land in their reports as well as ours. */
  var GA4_ID = 'G-QSR4FKY422';

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  function track(name, params) {
    var p = params || {};
    if (!p.send_to) p.send_to = GA4_ID;
    try {
      gtag('event', name, p);
    } catch (e) {
      /* Analytics must never break the page. */
    }
  }

  /* Let other scripts fire events without repeating the shim. */
  window.NPTA = window.NPTA || {};
  window.NPTA.track = track;

  if (!document.addEventListener || !Element.prototype.closest) return;

  /* What counts as a call to action. The theme has no single button class --
     sections use btn, __card-btn, __promo-btn and so on -- so this matches on
     the substring, plus the explicit add-to-cart hooks. Anything else can opt
     in with a data-cta attribute, which doubles as its label. */
  var CTA = [
    'a[class*="btn"]',
    'button[class*="btn"]',
    'a[class*="button"]',
    'button[class*="button"]',
    '[data-add-to-cart]',
    '[data-spx-atc]',
    '.npta-addon__add',
    '[data-cta]'
  ].join(',');

  /* Where on the page it sat, so two buttons reading "Add to Cart" can still
     be told apart in reporting. */
  function location_of(el) {
    var s = el.closest('[data-section-type]');
    if (s) return s.getAttribute('data-section-type');

    s = el.closest('.shopify-section, section[id]');
    if (s) {
      var id = s.getAttribute('id') || '';
      id = id.replace(/^shopify-section-/, '').replace(/^template--\d+__/, '');
      if (id) return id;
    }
    return 'page';
  }

  function label_of(el) {
    var text = el.getAttribute('data-cta') ||
               el.textContent ||
               el.getAttribute('aria-label') || '';
    return text.replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  /* Capture phase: some of these buttons preventDefault and tear their own
     markup down, so waiting for the bubble can mean the element is gone. */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest(CTA) : null;
    if (!el) return;

    var label = label_of(el);
    if (!label) return;  /* icon-only controls: arrows, steppers, close */

    track('cta_click', {
      cta_label: label,
      cta_location: location_of(el),
      page_path: window.location.pathname,
      link_url: el.getAttribute('href') || ''
    });
  }, true);
}());
